import React, { useState, useEffect } from "react";
import "./phoneCarousel.css";

const screenshots = [
    "https://sin-fila-assets.s3.us-east-1.amazonaws.com/screenshots/bookingModalScreenshots.png",
    "https://sin-fila-assets.s3.us-east-1.amazonaws.com/screenshots/calendarScreenshot.png",
    "https://sin-fila-assets.s3.us-east-1.amazonaws.com/screenshots/editShopScreenshots.png",
    "https://sin-fila-assets.s3.us-east-1.amazonaws.com/screenshots/shopScreenshots.png",
];

const PhoneCarousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(false); // start fade out

            setTimeout(() => {
                setCurrentIndex((prev) => (prev + 1) % screenshots.length);
                setFade(true); // fade back in
            }, 200); // must be shorter than CSS transition
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="sf-phone-carousel">
            <img
                src={screenshots[currentIndex]}
                alt="app preview"
                className={`sf-phone-image ${fade ? "fade-in" : "fade-out"}`}
            />
        </div>
    );
};

export default PhoneCarousel;